/**
 * PayTomorrow Monthly Payment Estimator – product page.
 * Markup + config: snippets/paytomorrow-estimator.liquid (Theme settings > PayTomorrow).
 *
 * PayTomorrow's script reads the price once and never follows variant changes, so the
 * price is fed to it through a hidden element that is updated from on:variant:change.
 * The library itself is loaded after the page has finished loading.
 */
(function () {
  if (window.__ptEstimatorInit) return;
  window.__ptEstimatorInit = true;

  var root = document.querySelector('[data-pt-estimator]');
  var cfgEl = document.querySelector('[data-pt-estimator-config]');
  if (!root || !cfgEl || root.closest('.quick-add__product-details')) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var CDN = 'https://cdn.paytomorrow.com';
  var priceEl = root.querySelector('[data-pt-price]');
  var section = root.closest('.shopify-section');
  var lastPrice = null;
  var pendingPrice = cfg.price;
  var libReady = false;
  var firstRender = true;

  function loadLib(done) {
    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = CDN + '/css/pt-mpe.min.css';
    document.head.appendChild(css);

    var js = document.createElement('script');
    js.src = CDN + '/js/pt-mpe.min.js';
    js.onload = done;
    document.head.appendChild(js);
  }

  function render(price) {
    if (price === lastPrice) return;
    lastPrice = price;

    /* Fresh target each time: drops the click listener the library attached to the old one */
    var old = root.querySelector('[data-pt-mpe]');
    var mpe = old.cloneNode(false);
    mpe.className = 'pt-estimator__mpe';
    old.replaceWith(mpe);

    priceEl.textContent = price ? String(price) : '';
    if (!price || !window.PayTomorrow) return;

    var isFirst = firstRender;
    firstRender = false;

    Promise.resolve(window.PayTomorrow.mpeInit({
      publicId: cfg.publicId,
      storeDisplayName: cfg.storeDisplayName,
      priceSelector: '[data-pt-estimator] [data-pt-price]',
      mpeSelector: '[data-pt-estimator] [data-pt-mpe]',
      minAmount: cfg.minAmount,
      maxAmount: cfg.maxAmount,
      maxTerm: cfg.maxTerm,
      displayPrimeOffers: cfg.displayPrimeOffers,
      primeApr: cfg.primeApr,
      primeHasZero: cfg.primeHasZero,
      logoColor: cfg.logoColor,
      prefixString: cfg.prefixString,
      postfixString: cfg.postfixString,
      /* The popup iframe is created by the first call only; later calls would duplicate it */
      enableMoreInfoLink: isFirst
    })).then(function () {
      root.classList.remove('pt-estimator--reserve');
      if (!isFirst && mpe.childElementCount && !mpe.querySelector('.__pt-info-link')) {
        var link = document.createElement('a');
        link.className = '__pt-info-link';
        link.textContent = cfg.postfixString;
        mpe.appendChild(link);
      }
    }).catch(function () {
      root.classList.remove('pt-estimator--reserve');
    });
  }

  document.addEventListener('on:variant:change', function (evt) {
    if (section && !section.contains(evt.target)) return;
    var variant = evt.detail && evt.detail.variant;
    pendingPrice = variant ? variant.price / 100 : null;
    if (libReady) render(pendingPrice);
  });

  function start() {
    loadLib(function () {
      libReady = true;
      render(pendingPrice);
    });
  }

  function whenIdle() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(start, { timeout: 3000 });
    } else {
      setTimeout(start, 1);
    }
  }

  if (document.readyState === 'complete') {
    whenIdle();
  } else {
    window.addEventListener('load', whenIdle, { once: true });
  }
})();
